// extracted by mini-css-extract-plugin
module.exports = {"slide":"DetailOrdersDeposit_slide_1LEN7","slide-reverse":"DetailOrdersDeposit_slide-reverse_Rdhjk","filter":"DetailOrdersDeposit_filter_3ZHRl"};